import { render, staticRenderFns } from "./cgsNumberGraphic.vue?vue&type=template&id=494fcd5b&"
import script from "./cgsNumberGraphic.vue?vue&type=script&lang=js&"
export * from "./cgsNumberGraphic.vue?vue&type=script&lang=js&"
import style0 from "./cgsNumberGraphic.vue?vue&type=style&index=0&id=494fcd5b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports